import { Injectable, signal} from '@angular/core';
import { iModal } from './entities';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly _modal = signal<iModal>({
     visible: false
  });
  
  readonly modal = this._modal.asReadonly();

  show(data: Omit<iModal, 'visible'>) {
    this._modal.set({
      visible: true,
      type: "form",
      ...data
    });
  }
  show_img(data: Omit<iModal, 'visible'>) {
    this._modal.set({
      visible: true,
      type: "img",
      ...data
    });
  }
  hide() {
    this._modal.set({ visible: false });
  }

}
